import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';



@Component({
    selector: 'app-drake-domain',
    templateUrl: './drake-domain.component.html',
    styleUrls: ['./drake-domain.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class DrakeDomainComponent implements OnInit {
    constructor(private router: Router) { }

    ngOnInit(): void {
        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userObj = JSON.parse(user);
                const domCode = userObj.domCode;
                if (domCode) {
                    this.router.navigateByUrl(`/d/DOMAINS/f/${domCode}/t/SETTINGS`, { skipLocationChange: true });
                } else {
                    console.error('Domain ID not found in local storage');
                }
            } catch (error) {
                console.error('Error parsing user JSON:', error);
            }
        } else {
            console.error('Domain not found in local storage');
        }
    }
}
